import { Vector3 } from "three";
import { BoneToVector } from "./index50.js";
import { getInnerLoadSide } from "./index225.js";
const _vectorA = new Vector3();
const _vectorB = new Vector3();
const _cross = new Vector3();
function hasBoneAt({ bone, right, start, innerLoad, outerLoad }) {
  const joint = bone.joints[start ? 0 : 1];
  BoneToVector(bone, _vectorA);
  const otherBones = joint.bones.filter((b) => b !== bone);
  for (const b of otherBones) {
    BoneToVector(b, _vectorB);
    const bFacesBone = bone.joints.includes(b.joints[1]);
    if (start && bFacesBone)
      _vectorB.negate();
    _cross.crossVectors(_vectorA, _vectorB);
    const isRight = _cross.y < 0;
    if (!right === isRight)
      continue;
    if (innerLoad === void 0 && outerLoad === void 0) {
      return true;
    } else {
      const inLoadIndex = getInnerLoadSide(bFacesBone, start, isRight);
      const outLoadIndex = inLoadIndex ? 0 : 1;
      const inPass = innerLoad === void 0 ? true : innerLoad === b.loads[inLoadIndex];
      const outPass = outerLoad === void 0 ? true : outerLoad === b.loads[outLoadIndex];
      if (inPass && outPass)
        return true;
      break;
    }
  }
  return false;
}
export {
  hasBoneAt
};
//# sourceMappingURL=index176.js.map
